import React from 'react'

function TravelTourismThree() {
   return (
      <section className="container-fluid section_primary_bg industries-bg-image">
         <div className="container text-center mb-4 innovation_comman blockchain_innovation">
            <h2 className="tech_title section_heading_title mb-2">
               Comprehensive Travel App & Software Solutions We Provide
            </h2>

            <p className="sub_body">
               We at Benzatine are experts in creating state-of-the-art travel apps and software solutions that improve the entire travel experience as well as business efficiency. We have the knowledge and expertise in travel app development to design innovative, user-focused platforms that can address the multi-faceted needs of the travel sector. From intuitive booking systems to intelligent itinerary planners, we equip your business with state-of-the-art technology.
            </p>
         </div>
         <div className="container text-center">
            <div className="innovation_card_main blockchain_innovation_card_main industry_web_new">
               <div className="row g-4 industry-grid travel-tourism-wrap">
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c1.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Taxi Booking App
                        </h4>
                        <p className="industry-description">
                           Provide on-demand transport convenience through a
                           taxi booking platform. Our app enables users to book
                           vehicles at their preferred locations, with
                           provisions for intercity and cross-country travel.
                           With real-time vehicle tracking and open payment
                           options, offer your customers hassle-free travel
                           experiences.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c2.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Car Rental App
                        </h4>
                        <p className="industry-description">
                           Our custom car rental app solutions make vehicle
                           rental services straightforward and efficient. Provide
                           your customers with access to a pool of cars with
                           flexible scheduling, safe payment methods, and easy
                           pick-up/drop-off points. Make the rental process
                           better with real-time vehicle availability and instant
                           confirmations.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c3.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Trip Planner App
                        </h4>
                        <p className="industry-description">
                           Allow your users to plan and book their trips
                           efficiently using an intelligent trip planning app.
                           From itinerary design and activity booking to cost
                           management, our app simplifies every part of trip
                           planning, offering convenience and trustworthiness.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c4.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Flight Booking App
                        </h4>
                        <p className="industry-description">
                           Streamline the process of booking a flight for your
                           users with an easy-to-use and intuitive app. As a
                           reliable travel app development agency, Benzatine
                           develops robust flight booking apps with real-time
                           flight data, adaptive search functionality, and
                           seamless payment integrations. Facilitate smooth
                           ticket booking and maximize customer satisfaction.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c5.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Tour Guide App
                        </h4>
                        <p className="industry-description">
                           Improve your customers' holidays with a feature-rich
                           tour guide application. Offer them turn-by-turn
                           real-time navigation, extensive destination
                           information, and locally personalized suggestions for
                           sights, activities, events, and restaurants. Offer
                           outstanding travel support in their pocket.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c6.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Travel Agent App
                        </h4>
                        <p className="industry-description">
                           Boost efficiency for travel agencies with a robust
                           travel agent app. Our offering gives agents the tools
                           to handle bookings, communicate with customers, and
                           access real-time travel information. Give your agents
                           the tools they need to optimize operations and
                           increase service quality.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c7.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Ticket and Hotel Booking App
                        </h4>
                        <p className="industry-description">
                           Simplify booking procedures with a ticket and hotel
                           reservation app. Our solution provides for simplified
                           hotel bookings, ticket buying, and instant
                           availability checks. Streamline the customer
                           experience with seamless booking management and
                           personalized service features.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c8.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Central Reservation System (CRS)
                        </h4>
                        <p className="industry-description">
                           Simplify booking and reservation procedures with a
                           central reservation system. Our CRS solution supports
                           businesses in effectively handling bookings, tracking
                           occupancy levels, and automating revenue channels.
                           Benefit from seamless third-party integration with
                           platforms and distribution networks.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c9.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Airport Transfer & Shuttle App
                        </h4>
                        <p className="industry-description">
                           Improve travel ease with our Airport Transfer &
                           Shuttle App. It simplifies booking a ride, real-time
                           tracking, and safe payments to provide guaranteed
                           airport transfers. With route optimization and
                           real-time notifications, travelers have easy and
                           hassle-free transfers.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c10.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Travel Map App
                        </h4>
                        <p className="industry-description">
                           Help travelers navigate with confidence using a travel
                           map app. Our solution provides interactive maps,
                           real-time GPS navigation, and local tips. Users can
                           discover nearby attractions, find restaurants, and get
                           directions, making their overall travel experience
                           better.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c11.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Business Travel App
                        </h4>
                        <p className="industry-description">
                           Assist corporate travelers with business travel
                           software that is meant to ease the planning and
                           management. Such software provides functionality such
                           as expense reporting, flight and hotel reservations,
                           and itinerary management. Ease business travel with
                           simple, efficient solutions.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/travelTourism/c12.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Adventure & Activity Booking App
                        </h4>
                        <p className="industry-description">
                           Enable travelers to explore new adventures with a
                           custom activity booking app. Provide facilities for
                           tour booking, excursions, and adventure activities.
                           Users are able to find local activities, book
                           instantly, and receive personalized recommendations.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default TravelTourismThree
